import React from 'react'
import cx from 'classnames'
import styles from './events-marquee.module.scss'
import { MarqueeV2 as Marquee } from '../marquee'

export default function VideoMarquee() {
  return (
    <div className={styles.section}>
      <Marquee duration="30s" pauseOnHover={false}>
        <div className={cx(styles.section__row, styles.request)}>
          <SVGRequestInvite />
        </div>
      </Marquee>
      <Marquee duration="30s" pauseOnHover={false} reverse>
        <div className={styles.section__row}>
          <SVGLearnMore />
        </div>
      </Marquee>
      <Marquee duration="30s" pauseOnHover={false}>
        <div className={styles.section__row}>
          <SVGStayInTouch />
        </div>
      </Marquee>
    </div>
  )
}

function SVGStayInTouch({ ...props }) {
  return (
    <svg
      width="1885"
      height="88"
      viewBox="0 0 1885 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.679993 58.9999C1.15999 77.4799 15.92 87.1999 40.4 87.1999C63.32 87.1999 75.8 78.3199 75.8 62.3599C75.8 49.3999 66.44 41.4799 47.6 38.4799L34.16 36.3199C22.76 34.3999 17.84 31.0399 17.84 24.1999C17.84 17.2399 25.76 11.8399 38.84 11.8399H40.76C54.2 11.8399 62.84 17.4799 64.28 27.1999H77.48C75.8 10.8799 62.12 0.799916 39.8 0.799916C16.76 0.799916 5.35999 12.1999 5.35999 24.5599C5.35999 39.1999 13.28 45.4399 31.88 48.5599L44.96 50.7199C57.92 52.7599 63.32 56.9599 63.32 63.3199C63.32 71.3599 56.24 76.1599 41.24 76.1599H39.32C23.84 76.1599 14.36 70.1599 13.88 58.9999H0.679993Z"
        fill="#1B7E78"
      />
      <path
        d="M113.529 85.9999H125.889V13.0399H160.689V1.99991H78.7287V13.0399H113.529V85.9999Z"
        fill="#1B7E78"
      />
      <path
        d="M216.226 85.9999H229.906L190.786 1.99991H174.706L135.466 85.9999H148.786L158.626 64.5199H206.386L216.226 85.9999ZM163.666 53.4799L182.506 12.6799L201.226 53.4799H163.666Z"
        fill="#1B7E78"
      />
      <path
        d="M276.017 1.99991L249.377 39.5599L222.497 1.99991H207.617L243.017 50.5999V85.9999H255.377V50.5999L290.777 1.99991H276.017Z"
        fill="#1B7E78"
      />
      <path
        d="M323.296 85.9999H335.656V1.99991H323.296V85.9999Z"
        fill="#1B7E78"
      />
      <path
        d="M422.401 1.99991V72.1999L373.561 1.99991H356.521V85.9999H368.881V15.9199L417.721 85.9999H434.761V1.99991H422.401Z"
        fill="#1B7E78"
      />
      <path
        d="M503.252 85.9999H515.612V13.0399H550.412V1.99991H468.452V13.0399H503.252V85.9999Z"
        fill="#1B7E78"
      />
      <path
        d="M545.601 43.9999C545.601 70.2799 565.281 87.1999 592.041 87.1999C618.561 87.4399 638.721 70.2799 638.361 43.9999C638.721 17.5999 618.561 0.559919 592.041 0.799916C565.521 0.439914 545.241 17.8399 545.601 43.9999ZM591.081 76.1599C572.961 76.1599 558.081 63.9199 558.081 43.9999C558.081 23.9599 572.961 11.8399 591.081 11.8399H593.001C611.001 11.8399 625.881 23.9599 625.881 43.9999C625.881 63.9199 611.001 76.1599 593.001 76.1599H591.081Z"
        fill="#1B7E78"
      />
      <path
        d="M652.875 52.8799C652.875 73.9999 665.235 87.1999 689.835 87.1999C713.955 87.1999 726.795 73.8799 726.795 52.8799V1.99991H714.435V51.9199C714.435 67.7599 706.155 76.1599 690.795 76.1599H688.875C673.515 76.1599 665.235 67.7599 665.235 51.9199V1.99991H652.875V52.8799Z"
        fill="#1B7E78"
      />
      <path
        d="M741.309 43.9999C740.949 68.8399 758.949 87.5599 786.789 87.1999C809.469 87.1999 824.469 75.9199 827.109 59.5999H813.909C811.509 70.5199 800.829 76.1599 787.749 76.1599H785.829C766.029 76.1599 753.789 62.3599 753.789 43.9999C753.789 25.6399 766.029 11.8399 785.829 11.8399H787.749C800.709 11.8399 811.509 17.9599 813.909 28.3999H827.109C824.709 13.2799 810.189 0.799916 786.789 0.799916C759.429 0.799916 741.309 19.2799 741.309 43.9999Z"
        fill="#1B7E78"
      />
      <path
        d="M842.043 85.9999H854.403V49.3999H908.283V85.9999H920.643V1.99991H908.283V38.3599H854.403V1.99991H842.043V85.9999Z"
        fill="#1B7E78"
      />
      <path
        d="M964.68 58.9999C965.16 77.4799 979.92 87.1999 1004.4 87.1999C1027.32 87.1999 1039.8 78.3199 1039.8 62.3599C1039.8 49.3999 1030.44 41.4799 1011.6 38.4799L998.16 36.3199C986.76 34.3999 981.84 31.0399 981.84 24.1999C981.84 17.2399 989.76 11.8399 1002.84 11.8399H1004.76C1018.2 11.8399 1026.84 17.4799 1028.28 27.1999H1041.48C1039.8 10.8799 1026.12 0.799916 1003.8 0.799916C980.76 0.799916 969.36 12.1999 969.36 24.5599C969.36 39.1999 977.28 45.4399 995.88 48.5599L1008.96 50.7199C1021.92 52.7599 1027.32 56.9599 1027.32 63.3199C1027.32 71.3599 1020.24 76.1599 1005.24 76.1599H1003.32C987.84 76.1599 978.36 70.1599 977.88 58.9999H964.68Z"
        fill="#000C2D"
      />
      <path
        d="M1077.53 85.9999H1089.89V13.0399H1124.69V1.99991H1042.73V13.0399H1077.53V85.9999Z"
        fill="#000C2D"
      />
      <path
        d="M1180.23 85.9999H1193.91L1154.79 1.99991H1138.71L1099.47 85.9999H1112.79L1122.63 64.5199H1170.39L1180.23 85.9999ZM1127.67 53.4799L1146.51 12.6799L1165.23 53.4799H1127.67Z"
        fill="#000C2D"
      />
      <path
        d="M1240.02 1.99991L1213.38 39.5599L1186.5 1.99991H1171.62L1207.02 50.5999V85.9999H1219.38V50.5999L1254.78 1.99991H1240.02Z"
        fill="#000C2D"
      />
      <path
        d="M1287.3 85.9999H1299.66V1.99991H1287.3V85.9999Z"
        fill="#000C2D"
      />
      <path
        d="M1386.4 1.99991V72.1999L1337.56 1.99991H1320.52V85.9999H1332.88V15.9199L1381.72 85.9999H1398.76V1.99991H1386.4Z"
        fill="#000C2D"
      />
      <path
        d="M1467.25 85.9999H1479.61V13.0399H1514.41V1.99991H1432.45V13.0399H1467.25V85.9999Z"
        fill="#000C2D"
      />
      <path
        d="M1509.6 43.9999C1509.6 70.2799 1529.28 87.1999 1556.04 87.1999C1582.56 87.4399 1602.72 70.2799 1602.36 43.9999C1602.72 17.5999 1582.56 0.559919 1556.04 0.799916C1529.52 0.439914 1509.24 17.8399 1509.6 43.9999ZM1555.08 76.1599C1536.96 76.1599 1522.08 63.9199 1522.08 43.9999C1522.08 23.9599 1536.96 11.8399 1555.08 11.8399H1557C1575 11.8399 1589.88 23.9599 1589.88 43.9999C1589.88 63.9199 1575 76.1599 1557 76.1599H1555.08Z"
        fill="#000C2D"
      />
      <path
        d="M1616.88 52.8799C1616.88 73.9999 1629.24 87.1999 1653.84 87.1999C1677.96 87.1999 1690.8 73.8799 1690.8 52.8799V1.99991H1678.44V51.9199C1678.44 67.7599 1670.16 76.1599 1654.8 76.1599H1652.88C1637.52 76.1599 1629.24 67.7599 1629.24 51.9199V1.99991H1616.88V52.8799Z"
        fill="#000C2D"
      />
      <path
        d="M1705.31 43.9999C1704.95 68.8399 1722.95 87.5599 1750.79 87.1999C1773.47 87.1999 1788.47 75.9199 1791.11 59.5999H1777.91C1775.51 70.5199 1764.83 76.1599 1751.75 76.1599H1749.83C1730.03 76.1599 1717.79 62.3599 1717.79 43.9999C1717.79 25.6399 1730.03 11.8399 1749.83 11.8399H1751.75C1764.71 11.8399 1775.51 17.9599 1777.91 28.3999H1791.11C1788.71 13.2799 1774.19 0.799916 1750.79 0.799916C1723.43 0.799916 1705.31 19.2799 1705.31 43.9999Z"
        fill="#000C2D"
      />
      <path
        d="M1806.04 85.9999H1818.4V49.3999H1872.28V85.9999H1884.64V1.99991H1872.28V38.3599H1818.4V1.99991H1806.04V85.9999Z"
        fill="#000C2D"
      />
    </svg>
  )
}

function SVGLearnMore({ ...props }) {
  return (
    <svg
      width="1793"
      height="88"
      viewBox="0 0 1793 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.474365 85.9999H70.9144V74.9599H12.8344V1.99991H0.474365V85.9999Z"
        fill="#0E0C83"
      />
      <path
        d="M94.6922 74.9599V48.3199H147.012V37.2799H94.6922V13.0399H154.212V1.99991H82.3322V85.9999H155.412V74.9599H94.6922Z"
        fill="#0E0C83"
      />
      <path
        d="M239.881 85.9999H253.561L214.441 1.99991H198.361L159.121 85.9999H172.441L182.281 64.5199H230.041L239.881 85.9999ZM187.321 53.4799L206.161 12.6799L224.881 53.4799H187.321Z"
        fill="#0E0C83"
      />
      <path
        d="M263.274 85.9999H275.634V52.3999H313.794C320.394 52.3999 322.314 54.0799 322.314 60.7999V85.9999H334.674V57.7999C334.674 49.1599 331.434 45.4399 322.914 45.4399C330.114 43.0399 336.354 35.2399 336.354 24.9199C336.354 11.7199 324.714 1.99991 308.874 1.99991H263.274V85.9999ZM275.634 41.3599V13.0399H307.074C317.634 13.0399 323.874 17.9599 323.874 26.9599C323.874 35.4799 317.394 41.3599 307.074 41.3599H275.634Z"
        fill="#0E0C83"
      />
      <path
        d="M420.739 1.99991V72.1999L371.899 1.99991H354.859V85.9999H367.219V15.9199L416.059 85.9999H433.099V1.99991H420.739Z"
        fill="#0E0C83"
      />
      <path
        d="M564.998 1.99991L534.998 75.1999L504.998 1.99991H484.238V85.9999H496.598V12.1999L526.838 85.9999H542.918L573.278 11.8399V85.9999H585.638V1.99991H564.998Z"
        fill="#0E0C83"
      />
      <path
        d="M601.126 43.9999C601.126 70.2799 620.806 87.1999 647.566 87.1999C674.086 87.4399 694.246 70.2799 693.886 43.9999C694.246 17.5999 674.086 0.559919 647.566 0.799916C621.046 0.439914 600.766 17.8399 601.126 43.9999ZM646.606 76.1599C628.486 76.1599 613.606 63.9199 613.606 43.9999C613.606 23.9599 628.486 11.8399 646.606 11.8399H648.526C666.526 11.8399 681.406 23.9599 681.406 43.9999C681.406 63.9199 666.526 76.1599 648.526 76.1599H646.606Z"
        fill="#0E0C83"
      />
      <path
        d="M709.36 85.9999H721.72V52.3999H759.88C766.48 52.3999 768.4 54.0799 768.4 60.7999V85.9999H780.76V57.7999C780.76 49.1599 777.52 45.4399 769 45.4399C776.2 43.0399 782.44 35.2399 782.44 24.9199C782.44 11.7199 770.8 1.99991 754.96 1.99991H709.36V85.9999ZM721.72 41.3599V13.0399H753.16C763.72 13.0399 769.96 17.9599 769.96 26.9599C769.96 35.4799 763.48 41.3599 753.16 41.3599H721.72Z"
        fill="#0E0C83"
      />
      <path
        d="M813.305 74.9599V48.3199H865.625V37.2799H813.305V13.0399H872.825V1.99991H800.945V85.9999H874.025V74.9599H813.305Z"
        fill="#0E0C83"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M930.669 75.9599V2.99991H920.309V84.9999H988.749V75.9599H930.669ZM989.749 74.9599V85.9999H919.309V1.99991H931.669V74.9599H989.749ZM1012.53 75.9599V47.3199H1064.85V38.2799H1012.53V12.0399H1072.05V2.99991H1002.17V84.9999H1073.25V75.9599H1012.53ZM1074.25 74.9599V85.9999H1001.17V1.99991H1073.05V13.0399H1013.53V37.2799H1065.85V48.3199H1013.53V74.9599H1074.25ZM1100.47 63.5199H1149.52L1159.36 84.9999H1170.83L1132.64 2.99991H1117.83L1079.53 84.9999H1090.63L1100.47 63.5199ZM1091.28 85.9999H1077.96L1117.2 1.99991H1133.28L1172.4 85.9999H1158.72L1148.88 64.5199H1101.12L1091.28 85.9999ZM1104.59 54.4799L1125 10.2883L1145.27 54.4799H1104.59ZM1243.94 44.5289C1250.17 41.4053 1255.19 34.1763 1255.19 24.9199C1255.19 11.7199 1243.55 1.99991 1227.71 1.99991H1182.11V85.9999H1194.47V52.3999H1232.63C1239.23 52.3999 1241.15 54.0799 1241.15 60.7999V85.9999H1253.51V57.7999C1253.51 50.0158 1250.88 46.2252 1244.13 45.5506C1243.38 45.4764 1242.59 45.4399 1241.75 45.4399C1242.49 45.1926 1243.22 44.8878 1243.94 44.5289ZM1252.51 84.9999V57.7999C1252.51 53.5667 1251.71 50.7933 1250.09 49.062C1248.49 47.3475 1245.89 46.4399 1241.75 46.4399L1241.43 44.4912C1248.2 42.2362 1254.19 34.8381 1254.19 24.9199C1254.19 12.4341 1243.17 2.99991 1227.71 2.99991H1183.11V84.9999H1193.47V51.3999H1232.63C1235.93 51.3999 1238.44 51.7982 1240.06 53.3605C1241.69 54.9328 1242.15 57.4236 1242.15 60.7999V84.9999H1252.51ZM1193.47 42.3599V12.0399H1225.91C1231.33 12.0399 1235.78 13.3007 1238.9 15.8508C1242.05 18.4254 1243.71 22.2102 1243.71 26.9599C1243.71 31.4897 1241.98 35.3717 1238.84 38.1089C1235.71 40.8358 1231.25 42.3599 1225.91 42.3599H1193.47ZM1334.89 85.9999H1351.93V1.99991H1339.57V72.1999L1290.73 1.99991H1273.69V85.9999H1286.05V15.9199L1334.89 85.9999ZM1285.05 84.9999V12.736L1335.42 84.9999H1350.93V2.99991H1340.57V75.3883L1290.21 2.99991H1274.69V84.9999H1285.05ZM1492.11 85.9999H1504.47V1.99991H1483.83L1453.83 75.1999L1423.83 1.99991H1403.07V85.9999H1415.43V12.1999L1445.67 85.9999H1461.75L1492.11 11.8399V85.9999ZM1461.08 84.9999L1491.19 11.4611L1493.11 11.8399V84.9999H1503.47V2.99991H1484.5L1453.83 77.8369L1423.16 2.99991H1404.07V84.9999H1414.43V12.1999L1416.36 11.8208L1446.34 84.9999H1461.08ZM1520.96 43.9862L1520.96 43.9999C1520.96 56.8754 1525.77 67.4008 1533.82 74.715C1541.87 82.0377 1553.23 86.1999 1566.4 86.1999H1566.41C1579.45 86.318 1590.87 82.1579 1598.97 74.8046C1607.06 67.46 1611.9 56.8786 1611.72 44.0136L1611.72 43.9999L1611.72 43.9863C1611.9 31.0603 1607.06 20.4796 1598.97 13.1509C1590.87 5.81304 1579.46 1.68182 1566.41 1.79988L1566.4 1.79998L1566.39 1.79982C1553.35 1.62282 1541.9 5.81103 1533.77 13.1952C1525.65 20.5713 1520.78 31.1836 1520.96 43.9862ZM1690.02 44.5289C1696.25 41.4053 1701.27 34.1763 1701.27 24.9199C1701.27 11.7199 1689.63 1.99991 1673.79 1.99991H1628.19V85.9999H1640.55V52.3999H1678.71C1685.31 52.3999 1687.23 54.0799 1687.23 60.7999V85.9999H1699.59V57.7999C1699.59 50.0158 1696.96 46.2252 1690.21 45.5506C1689.47 45.4764 1688.68 45.4399 1687.83 45.4399C1688.58 45.1926 1689.31 44.8878 1690.02 44.5289ZM1698.59 84.9999V57.7999C1698.59 53.5667 1697.79 50.7933 1696.18 49.062C1694.58 47.3475 1691.98 46.4399 1687.83 46.4399L1687.52 44.4912C1694.28 42.2362 1700.27 34.8381 1700.27 24.9199C1700.27 12.4341 1689.26 2.99991 1673.79 2.99991H1629.19V84.9999H1639.55V51.3999H1678.71C1682.02 51.3999 1684.53 51.7982 1686.14 53.3605C1687.77 54.9328 1688.23 57.4236 1688.23 60.7999V84.9999H1698.59ZM1639.55 42.3599V12.0399H1671.99C1677.41 12.0399 1681.87 13.3007 1684.99 15.8508C1688.14 18.4254 1689.79 22.2102 1689.79 26.9599C1689.79 31.4897 1688.06 35.3717 1684.92 38.1089C1681.79 40.8358 1677.34 42.3599 1671.99 42.3599H1639.55ZM1731.14 75.9599V47.3199H1783.46V38.2799H1731.14V12.0399H1790.66V2.99991H1720.78V84.9999H1791.86V75.9599H1731.14ZM1792.86 74.9599V85.9999H1719.78V1.99991H1791.66V13.0399H1732.14V37.2799H1784.46V48.3199H1732.14V74.9599H1792.86ZM1106.16 53.4799H1143.72L1125 12.6799L1106.16 53.4799ZM1541.47 68.2832C1535.27 62.5345 1531.44 54.224 1531.44 43.9999C1531.44 33.7172 1535.27 25.4056 1541.47 19.6707C1547.66 13.945 1556.16 10.8399 1565.44 10.8399H1567.36C1576.58 10.8399 1585.05 13.946 1591.23 19.6716C1597.42 25.4063 1601.24 33.7173 1601.24 43.9999C1601.24 54.2239 1597.41 62.5338 1591.23 68.2823C1585.06 74.0222 1576.59 77.1599 1567.36 77.1599H1565.44C1556.16 77.1599 1547.66 74.0232 1541.47 68.2832ZM1566.4 87.1999C1539.64 87.1999 1519.96 70.2799 1519.96 43.9999C1519.6 17.8399 1539.88 0.439914 1566.4 0.799916C1592.92 0.559919 1613.08 17.5999 1612.72 43.9999C1613.08 70.2799 1592.92 87.4399 1566.4 87.1999ZM1532.44 43.9999C1532.44 63.9199 1547.32 76.1599 1565.44 76.1599H1567.36C1585.36 76.1599 1600.24 63.9199 1600.24 43.9999C1600.24 23.9599 1585.36 11.8399 1567.36 11.8399H1565.44C1547.32 11.8399 1532.44 23.9599 1532.44 43.9999ZM1194.47 13.0399H1225.91C1236.47 13.0399 1242.71 17.9599 1242.71 26.9599C1242.71 35.4799 1236.23 41.3599 1225.91 41.3599H1194.47V13.0399ZM1640.55 13.0399H1671.99C1682.55 13.0399 1688.79 17.9599 1688.79 26.9599C1688.79 35.4799 1682.31 41.3599 1671.99 41.3599H1640.55V13.0399Z"
        fill="#000C2D"
      />
    </svg>
  )
}

function SVGRequestInvite({ ...props }) {
  return (
    <svg
      width="2171"
      height="109"
      viewBox="0 0 2171 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1108 85.2055H1120.36V51.6055H1158.52C1165.12 51.6055 1167.04 53.2855 1167.04 60.0055V85.2055H1179.4V57.0055C1179.4 48.3655 1176.16 44.6455 1167.64 44.6455C1174.84 42.2455 1181.08 34.4455 1181.08 24.1255C1181.08 10.9255 1169.44 1.20548 1153.6 1.20548H1108V85.2055ZM1120.36 40.5655V12.2455H1151.8C1162.36 12.2455 1168.6 17.1655 1168.6 26.1655C1168.6 34.6855 1162.12 40.5655 1151.8 40.5655H1120.36Z"
        fill="#000C2D"
      />
      <path
        d="M1211.94 74.1655V47.5255H1264.26V36.4855H1211.94V12.2455H1271.46V1.20548H1199.58V85.2055H1272.66V74.1655H1211.94Z"
        fill="#000C2D"
      />
      <path
        d="M1318.58 97.8055C1318.58 104.405 1322.66 108.005 1329.38 108.005H1358.3V96.9655H1335.26C1331.54 96.9655 1330.46 95.7655 1330.46 92.0455V86.1655C1354.46 84.2455 1371.26 67.8055 1371.26 43.2055C1371.62 16.8055 1351.46 -0.234514 1324.94 0.00548245C1298.42 -0.35452 1278.14 17.0455 1278.5 43.2055C1278.5 67.4455 1295.18 83.6455 1318.58 86.0455V97.8055ZM1323.98 75.3655C1305.86 75.3655 1290.98 63.1255 1290.98 43.2055C1290.98 23.1655 1305.86 11.0455 1323.98 11.0455H1325.9C1343.9 11.0455 1358.78 23.1655 1358.78 43.2055C1358.78 63.1255 1343.9 75.3655 1325.9 75.3655H1323.98Z"
        fill="#000C2D"
      />
      <path
        d="M1385.78 52.0855C1385.78 73.2055 1398.14 86.4055 1422.74 86.4055C1446.86 86.4055 1459.7 73.0855 1459.7 52.0855V1.20548H1447.34V51.1255C1447.34 66.9655 1439.06 75.3655 1423.7 75.3655H1421.78C1406.42 75.3655 1398.14 66.9655 1398.14 51.1255V1.20548H1385.78V52.0855Z"
        fill="#000C2D"
      />
      <path
        d="M1491.97 74.1655V47.5255H1544.29V36.4855H1491.97V12.2455H1551.49V1.20548H1479.61V85.2055H1552.69V74.1655H1491.97Z"
        fill="#000C2D"
      />
      <path
        d="M1560.72 58.2055C1561.2 76.6855 1575.96 86.4055 1600.44 86.4055C1623.36 86.4055 1635.84 77.5255 1635.84 61.5655C1635.84 48.6055 1626.48 40.6855 1607.64 37.6855L1594.2 35.5255C1582.8 33.6055 1577.88 30.2455 1577.88 23.4055C1577.88 16.4455 1585.8 11.0455 1598.88 11.0455H1600.8C1614.24 11.0455 1622.88 16.6855 1624.32 26.4055H1637.52C1635.84 10.0855 1622.16 0.00548245 1599.84 0.00548245C1576.8 0.00548245 1565.4 11.4055 1565.4 23.7655C1565.4 38.4055 1573.32 44.6455 1591.92 47.7655L1605 49.9255C1617.96 51.9655 1623.36 56.1655 1623.36 62.5255C1623.36 70.5655 1616.28 75.3655 1601.28 75.3655H1599.36C1583.88 75.3655 1574.4 69.3655 1573.92 58.2055H1560.72Z"
        fill="#000C2D"
      />
      <path
        d="M1673.57 85.2055H1685.93V12.2455H1720.73V1.20548H1638.77V12.2455H1673.57V85.2055Z"
        fill="#000C2D"
      />
      <path
        d="M1754.42 85.2055H1766.78V1.20548H1754.42V85.2055Z"
        fill="#000C2D"
      />
      <path
        d="M1853.53 1.20548V71.4055L1804.69 1.20548H1787.65V85.2055H1800.01V15.1255L1848.85 85.2055H1865.89V1.20548H1853.53Z"
        fill="#000C2D"
      />
      <path
        d="M1957.05 1.20548L1923.33 74.7655L1889.37 1.20548H1875.45L1914.81 85.2055H1931.49L1970.73 1.20548H1957.05Z"
        fill="#000C2D"
      />
      <path
        d="M1980.43 85.2055H1992.79V1.20548H1980.43V85.2055Z"
        fill="#000C2D"
      />
      <path
        d="M2038.97 85.2055H2051.33V12.2455H2086.13V1.20548H2004.17V12.2455H2038.97V85.2055Z"
        fill="#000C2D"
      />
      <path
        d="M2109.86 74.1655V47.5255H2162.18V36.4855H2109.86V12.2455H2169.38V1.20548H2097.5V85.2055H2170.58V74.1655H2109.86Z"
        fill="#000C2D"
      />
      <path
        d="M0 85.2055H12.36V51.6055H50.52C57.12 51.6055 59.04 53.2855 59.04 60.0055V85.2055H71.4V57.0055C71.4 48.3655 68.16 44.6455 59.64 44.6455C66.84 42.2455 73.08 34.4455 73.08 24.1255C73.08 10.9255 61.44 1.20548 45.6 1.20548H0V85.2055ZM12.36 40.5655V12.2455H43.8C54.36 12.2455 60.6 17.1655 60.6 26.1655C60.6 34.6855 54.12 40.5655 43.8 40.5655H12.36Z"
        fill="#46E39A"
      />
      <path
        d="M103.944 74.1655V47.5255H156.264V36.4855H103.944V12.2455H163.464V1.20548H91.5844V85.2055H164.664V74.1655H103.944Z"
        fill="#46E39A"
      />
      <path
        d="M210.583 97.8055C210.583 104.405 214.663 108.005 221.383 108.005H250.303V96.9655H227.263C223.543 96.9655 222.463 95.7655 222.463 92.0455V86.1655C246.463 84.2455 263.263 67.8055 263.263 43.2055C263.623 16.8055 243.463 -0.234514 216.943 0.00548245C190.423 -0.35452 170.143 17.0455 170.503 43.2055C170.503 67.4455 187.183 83.6455 210.583 86.0455V97.8055ZM215.983 75.3655C197.863 75.3655 182.983 63.1255 182.983 43.2055C182.983 23.1655 197.863 11.0455 215.983 11.0455H217.903C235.903 11.0455 250.783 23.1655 250.783 43.2055C250.783 63.1255 235.903 75.3655 217.903 75.3655H215.983Z"
        fill="#46E39A"
      />
      <path
        d="M277.777 52.0855C277.777 73.2055 290.137 86.4055 314.737 86.4055C338.857 86.4055 351.697 73.0855 351.697 52.0855V1.20548H339.337V51.1255C339.337 66.9655 331.057 75.3655 315.697 75.3655H313.777C298.417 75.3655 290.137 66.9655 290.137 51.1255V1.20548H277.777V52.0855Z"
        fill="#46E39A"
      />
      <path
        d="M383.971 74.1655V47.5255H436.291V36.4855H383.971V12.2455H443.491V1.20548H371.611V85.2055H444.691V74.1655H383.971Z"
        fill="#46E39A"
      />
      <path
        d="M452.72 58.2055C453.2 76.6855 467.96 86.4055 492.44 86.4055C515.36 86.4055 527.84 77.5255 527.84 61.5655C527.84 48.6055 518.48 40.6855 499.64 37.6855L486.2 35.5255C474.8 33.6055 469.88 30.2455 469.88 23.4055C469.88 16.4455 477.8 11.0455 490.88 11.0455H492.8C506.24 11.0455 514.88 16.6855 516.32 26.4055H529.52C527.84 10.0855 514.16 0.00548245 491.84 0.00548245C468.8 0.00548245 457.4 11.4055 457.4 23.7655C457.4 38.4055 465.32 44.6455 483.92 47.7655L497 49.9255C509.96 51.9655 515.36 56.1655 515.36 62.5255C515.36 70.5655 508.28 75.3655 493.28 75.3655H491.36C475.88 75.3655 466.4 69.3655 465.92 58.2055H452.72Z"
        fill="#46E39A"
      />
      <path
        d="M565.568 85.2055H577.928V12.2455H612.728V1.20548H530.768V12.2455H565.568V85.2055Z"
        fill="#46E39A"
      />
      <path
        d="M646.425 85.2055H658.785V1.20548H646.425V85.2055Z"
        fill="#46E39A"
      />
      <path
        d="M745.53 1.20548V71.4055L696.69 1.20548H679.65V85.2055H692.01V15.1255L740.85 85.2055H757.89V1.20548H745.53Z"
        fill="#46E39A"
      />
      <path
        d="M849.054 1.20548L815.334 74.7655L781.374 1.20548H767.454L806.814 85.2055H823.494L862.734 1.20548H849.054Z"
        fill="#46E39A"
      />
      <path
        d="M872.428 85.2055H884.788V1.20548H872.428V85.2055Z"
        fill="#46E39A"
      />
      <path
        d="M930.973 85.2055H943.333V12.2455H978.133V1.20548H896.173V12.2455H930.973V85.2055Z"
        fill="#46E39A"
      />
      <path
        d="M1001.86 74.1655V47.5255H1054.18V36.4855H1001.86V12.2455H1061.38V1.20548H989.503V85.2055H1062.58V74.1655H1001.86Z"
        fill="#46E39A"
      />
    </svg>
  )
}
